// ABOUTME: Edit pencil icon with document outline
// ABOUTME: Supports className, size, and color customization

interface IconProps {
  className?: string
  size?: number
  color?: string
}

export const EditPencilIcon = ({ className = "", size = 13, color = "#1F2A37" }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10.1566 1.09189C9.99396 1.16177 9.84683 1.26335 9.72384 1.39069L3.99984 7.11469V9.00003H5.88517L11.6092 3.27603C11.7365 3.15303 11.8381 3.0059 11.908 2.84323C11.9779 2.68056 12.0146 2.5056 12.0162 2.32856C12.0177 2.15152 11.984 1.97595 11.9169 1.81209C11.8499 1.64823 11.7509 1.49936 11.6257 1.37417C11.5005 1.24898 11.3516 1.14997 11.1878 1.08293C11.0239 1.01589 10.8483 0.982154 10.6713 0.983693C10.4943 0.985231 10.3193 1.02201 10.1566 1.09189Z"
      fill={color}
    />
    <path
      d="M5.33317 2.33336H1.99984C1.64622 2.33336 1.30708 2.47384 1.05703 2.72388C0.80698 2.97393 0.666504 3.31307 0.666504 3.66669V11C0.666504 11.3536 0.80698 11.6928 1.05703 11.9428C1.30708 12.1929 1.64622 12.3334 1.99984 12.3334H9.33317C9.68679 12.3334 10.0259 12.1929 10.276 11.9428C10.526 11.6928 10.6665 11.3536 10.6665 11V7.66669M9.72384 1.39069C9.84683 1.26335 9.99396 1.16177 10.1566 1.09189C10.3193 1.02201 10.4943 0.985231 10.6713 0.983693C10.8483 0.982154 11.0239 1.01589 11.1878 1.08293C11.3516 1.14997 11.5005 1.24898 11.6257 1.37417C11.7509 1.49936 11.8499 1.64823 11.9169 1.81209C11.984 1.97595 12.0177 2.15152 12.0162 2.32856C12.0146 2.5056 11.9779 2.68056 11.908 2.84323C11.8381 3.0059 11.7365 3.15303 11.6092 3.27603L5.88517 9.00003H3.99984V7.11469L9.72384 1.39069Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
